import POVBlock from '../POVBlock/POVBlock';
import Quote from '../Quote/Quote';

class Office {
  constructor(contentfulNode, globalOfficeReference) {
    this.order = contentfulNode?.order || globalOfficeReference?.order;
    this.locationName = contentfulNode?.locationName || globalOfficeReference?.locationName;
    this.address1 = contentfulNode?.address1 || globalOfficeReference?.address1;
    this.address2 = contentfulNode?.address2 || globalOfficeReference?.address2 || '';
    this.citystatezip = contentfulNode?.citystatezip || globalOfficeReference?.citystatezip;
    this.phoneNumber = contentfulNode?.phoneNumber || globalOfficeReference?.phoneNumber || '';
    this.slug = contentfulNode?.slug || globalOfficeReference?.slug;
    this.localizationSlug = contentfulNode?.localizationSlug || globalOfficeReference?.localizationSlug;
    this.thumbnail = contentfulNode?.thumbnail
      ? {
          fluid: contentfulNode?.thumbnail?.gatsbyImageData,
          title: contentfulNode?.title
        }
      : globalOfficeReference?.thumbnail
      ? {
          fluid: globalOfficeReference?.thumbnail?.gatsbyImageData,
          title: globalOfficeReference?.title
        }
      : null;
    this.heroImage = contentfulNode?.heroImage
      ? {
          fluid: contentfulNode?.heroImage?.gatsbyImageData
        }
      : globalOfficeReference?.heroImage
      ? {
          fluid: globalOfficeReference?.heroImage?.gatsbyImageData
        }
      : null;
    this.description =
      contentfulNode?.description?.description || globalOfficeReference?.description?.description || '';
    this.leadershipLabel = contentfulNode?.leadershipLabel || globalOfficeReference?.leadershipLabel || '';
    this.leadershipTitle = contentfulNode?.leadershipTitle || globalOfficeReference?.leadershipTitle || '';
    this.leadershipBodyRichText =
      contentfulNode?.leadershipBodyRichText || globalOfficeReference?.leadershipBodyRichText || '';
    this.leaders = contentfulNode?.leadership
      ? contentfulNode?.leadership
      : globalOfficeReference?.leadership
      ? globalOfficeReference?.leadership
      : [];
    this.ourPurpose = contentfulNode?.ourPurpose
      ? new POVBlock(contentfulNode.ourPurpose)
      : globalOfficeReference?.ourPurpose
      ? new POVBlock(globalOfficeReference.ourPurpose)
      : null;
    this.joinTheTeam = contentfulNode?.joinTheTeam
      ? new POVBlock(contentfulNode.joinTheTeam)
      : globalOfficeReference?.joinTheTeam
      ? new POVBlock(globalOfficeReference.joinTheTeam)
      : null;
    this.quote = contentfulNode?.quote
      ? new Quote(contentfulNode?.quote)
      : globalOfficeReference?.quote
      ? new Quote(globalOfficeReference?.quote)
      : null;
    this.photoTitle = contentfulNode?.photoTitle || globalOfficeReference?.photoTitle || '';
    this.photos = contentfulNode?.photos
      ? contentfulNode?.photos
      : globalOfficeReference?.photos
      ? globalOfficeReference?.photos
      : [];
  }
}

export default Office;
